import { Component, Input } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { BaseValueAccessor } from 'src/app/core/base/base.value-accessor';
import { ODONTO_MODULE_CONSTANTS } from '../../odonto.constants';

@Component({
  selector: 'ms-odonto-subject',
  templateUrl: './odonto.subject.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: OdontoSubjectComponent,
      multi: true,
    },
  ],
})
export class OdontoSubjectComponent extends BaseValueAccessor<string> {
  readonly screen = ODONTO_MODULE_CONSTANTS;
  @Input() turn = -1;
  @Input() readonly = false;
}

@Component({
  selector: 'ms-odonto-disease',
  templateUrl: './odonto.disease.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: OdontoDiseaseComponent,
      multi: true,
    },
  ],
})
export class OdontoDiseaseComponent extends BaseValueAccessor<string> {
  readonly screen = ODONTO_MODULE_CONSTANTS;
  @Input() turn = -1;
  @Input() readonly = false;
}

@Component({
  selector: 'ms-odonto-additional-information',
  templateUrl: './odonto.additional-information.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: OdontoAdditionalInformationComponent,
      multi: true,
    },
  ],
})
export class OdontoAdditionalInformationComponent extends BaseValueAccessor<string> {
  readonly screen = ODONTO_MODULE_CONSTANTS;
  @Input() turn = -1;
  @Input() readonly = false;
}
